// Lightweight analytics hook: forwards events to PostHog when the
// platform-provided snippet is present. No paid service required.
export const track = (event, props = {}) => {
    try {
        if (typeof window !== "undefined" && window.posthog?.capture) {
            window.posthog.capture(event, props);
        }
    } catch {
        // analytics must never break the page
    }
};
